const initialAffiliates = {
  affiliateHierarchies: {},
};

export default initialAffiliates;
